/**
 * creates screen width breakpoint media string for useMedia hook
 * @param screenWidthBreakpointValue{number} - screen width
 * @return {string}
 * */
export const getScreenWidthBreakpointMedia = (screenWidthBreakpointValue) =>
  `(max-width: ${screenWidthBreakpointValue}px)`;
